// extracted by mini-css-extract-plugin
export default {"solarComponentWrapper":"solar-component_solarComponentWrapper__uwPj0"};